import store from 'Redux/store';
import { get, post } from 'Api';
import { setUnsubscribeSuccess, setUnsubscribeError } from 'Redux/ducks/unsubscribe-message';
import { NEW_ACCOUNT_PREFERENCE_CENTRE, NEW_ACCOUNT_LISTS, SAVE_LISTS, RESET_ACCOUNT_PREFERENCE_CENTRE } from 'Redux/reducers/account-preference-centre';

const scrollToTop = () => {
  if (document.documentElement && document.documentElement.scrollTo) {
    document.documentElement.scrollTo(0, 0);
  } else {
    window.scrollTo(0, 0);
  }
};

export function getAccountPreferenceCentre() {
  return async (dispatch) => {
    const { response, data } = await get(dispatch, '/crm/get-preference-lists');
    if (response.ok) {
      dispatch({
        type: NEW_ACCOUNT_PREFERENCE_CENTRE,
        payload: data,
      });
    }
  };
}

export function getAccountLists(emailPassed) {
  const state = store.getState();
  const auth = state.auth || {};
  let email = auth.email || '';
  if (emailPassed) {
    email = emailPassed;
  }
  return async (dispatch) => {
    const { response, data } = await post(dispatch, '/crm/account-lists', { email });
    if (response.ok) {
      dispatch({
        type: NEW_ACCOUNT_LISTS,
        payload: data,
      });
    }
  };
}

export function saveLists(selectedItems, unsubscribeData, emailPassed) {
  const state = store.getState();
  const auth = state.auth || {};
  let email = auth.email || '';
  if (emailPassed) {
    email = emailPassed;
  }
  return async (dispatch) => {
    const { response } = await post(dispatch, '/crm/save-lists', { lists: selectedItems, email, unsubscribeData });
    if (response.ok) {
      if (unsubscribeData) {
        setUnsubscribeSuccess();
      }
      scrollToTop();
      return dispatch({
        type: SAVE_LISTS,
        payload: false,
      });
    }
    if (unsubscribeData) {
      return setUnsubscribeError();
    }
    scrollToTop();
    return dispatch({
      type: SAVE_LISTS,
      payload: !unsubscribeData,
    });
  };
}

export function resetAccountPreferenceCentre() {
  return store.dispatch({ type: RESET_ACCOUNT_PREFERENCE_CENTRE });
}
